

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import store from './vuex/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import * as types from './vuex/types.js'
import {
routes
} from './router/index'
import {
timeToNow,
getValue,
transTime,
timeToCur,
timeToDay,
timeByRecharge
} from './filters'
import {
get
} from './util'
import App from './App'
require('swiper/dist/css/swiper.css')

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueAwesomeSwiper)
Vue.use(AlertPlugin)
Vue.use(ConfirmPlugin)
Vue.use(WechatPlugin)

/** 过滤函数 **/
Vue.filter('timeToNow', timeToNow)
Vue.filter('getValue', getValue)
Vue.filter('transTime', transTime)
Vue.filter('timeToCur', timeToCur)
Vue.filter('timeToDay', timeToDay)
Vue.filter('timeByRecharge', timeByRecharge)

/** 延迟点击 **/
FastClick.attach(document.body)

const history = window.sessionStorage
history.clear()
let historyCount = history.getItem('count') * 1 || 0
history.setItem('/', 0)

const router = new VueRouter({
base: __dirname,
routes: routes
})

/**
* [路由钩子]
* @type {Boolean}
*/
router.beforeEach(function(to, from, next) {
store.commit(types.UPDATE_LOADING, true)

const toIndex = history.getItem(to.path)
const fromIndex = history.getItem(from.path)

if (toIndex) {
if (toIndex > fromIndex || !fromIndex || (toIndex === '0' && fromIndex === '0')) {
store.commit(types.UPDATE_DIRECTION, 'forward')
} else {
store.commit(types.UPDATE_DIRECTION, 'reverse')
}
} else {
++historyCount
history.setItem('count', historyCount)
to.path !== '/' && history.setItem(to.path, historyCount)
store.commit(types.UPDATE_DIRECTION, 'forward')
}

next()
})

router.afterEach(function(to) {
store.commit(types.UPDATE_LOADING, false)

if (process.env.NODE_ENV === 'production') {
_hmt.push(['_trackPageview', to.fullPath])
}
})

/* eslint-disable no-new */
new Vue({
el: '#app-box',
store,
router,
template: '<App/>',
components: {
App
}
})



// WEBPACK FOOTER //
// ./src/main.js